var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "checkbox-grid-container" }, [
    _c("table", { staticClass: "checkbox-grid-table" }, [
      _c("thead", [
        _c(
          "tr",
          [
            _c("th", { staticClass: "row-label-header" }),
            _vm._v(" "),
            _vm._l(_vm.field.grid_columns, function(column, cIdx) {
              return _c(
                "th",
                { key: "col-" + cIdx, staticClass: "column-label" },
                [_vm._v("\n          " + _vm._s(column.label) + "\n        ")]
              )
            })
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.field.grid_rows, function(row, rIdx) {
          return _c(
            "tr",
            { key: "row-" + rIdx, staticClass: "grid-row" },
            [
              _c("td", { staticClass: "row-label" }, [
                _vm._v(_vm._s(row.label))
              ]),
              _vm._v(" "),
              _vm._l(_vm.field.grid_columns, function(column, cIdx) {
                return _c(
                  "td",
                  { key: "cell-" + cIdx, staticClass: "checkbox-cell" },
                  [
                    _c("div", { staticClass: "checkbox-wrapper" }, [
                      _c("input", {
                        attrs: {
                          type: "checkbox",
                          name: "field_" + _vm.field.id + "_" + rIdx
                        }
                      })
                    ])
                  ]
                )
              })
            ],
            2
          )
        }),
        0
      )
    ]),
    _vm._v(" "),
    _vm.field.help
      ? _c("p", { staticClass: "help-text" }, [_vm._v(_vm._s(_vm.field.help))])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }